import React, { useMemo, useState, useEffect } from 'react';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { VerbalAuthorizationComponent } from 'gw-capability-policychange-common-react';
import { MLFormService } from 'ml-services-common-react';
import { platformMessages } from 'ml-components-platform-react';

import metadata from './MLRewriteVerbalAuthorizationPage.metadata.json5';
import messages from './MLRewriteVerbalAuthorizationPage.messages';
import styles from './MLRewriteVerbalAuthorizationPage.module.scss'

function MLRewriteVerbalAuthorizationPage(props){

    const {
        updateWizardData, wizardData, goNext, currentStep
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [isLoading, setIsLoading] = useState(true);

    const ModalService = MLModalService();


    const shouldSkip = () => {
        return !!currentStep.stepHidden
    }

    useEffect(() => {
        if(shouldSkip()){
            goNext();
        }else{
            setIsLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onNext = () => {
        const updateFormPromise = MLFormService.updateForms(submissionVM.jobNumber.value, submissionVM.forms_ML.value, authHeader);
        ModalService.showProgressDialog(platformMessages.loading, updateFormPromise);
        updateFormPromise.then(() => {
            goNext();
        })
    }

    const allForms = submissionVM.forms_ML;

    const verbalAuthForms = useMemo(() => {
        return allForms.filter((form) => {
            return form.verbalAuthorization_ML.value === true;
        })
    }, [allForms]);

    const convertDateToUTC = (date) =>{
        if (date) {
            return date.toLocaleString('en-US', { timeZone: 'UTC', month: 'numeric', day: 'numeric', year: '2-digit', hour: '2-digit', minute: '2-digit'});
        }
        return '';
    };  


    const overrideProps = {
        verbalAuthorization: {
            verbalAuthForms,
            convertDateToUTC
        },
        nextDescription: {
            content: <>{translator(messages.nextDescription, { strong: (chunks) => <strong>{chunks}</strong> })}</>
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext
        },
        resolveComponentMap: {
            VerbalAuthorizationComponent
        }
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                
            />
        </WizardPage>
    );
}

export default MLRewriteVerbalAuthorizationPage;